import { Box } from "@chakra-ui/react"

const Gallery=()=>{
    return(
        <Box>gallery</Box>
    )
}

export default Gallery